/* Far Afield — deliberate size choice, including Shopify variant refreshes.
   Works with the existing Shopify product form and sticky action; no cart clone. */
(() => {
  'use strict';

  const rootSelector = 'product-info[data-fa-requires-size-choice="true"]';
  const buttonSelector = '.product-form__submit, .product__sticky-cart .product-bar__submit';
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || !root.matches(rootSelector) || root.dataset.faSizeChoiceReady === 'true') return;
    const findPicker = () => root.querySelector('[data-fa-size-picker]');
    if (!findPicker()) return;
    root.dataset.faSizeChoiceReady = 'true';

    // Liquid's selected variant is only intentional when the URL explicitly
    // addresses it. Never use Shopify's first-available fallback as consent.
    const query = new URLSearchParams(window.location.search);
    const explicitVariant = query.has('variant') || query.has('option_values');
    if (!explicitVariant) root.dataset.faSizeChosen = 'false';
    const hasAvailableSize = root.dataset.faHasAvailableVariant !== 'false';
    const chosen = () => root.dataset.faSizeChosen === 'true';
    let pending = false;

    function clearImplicitSelection() {
      if (chosen()) return;
      const field = findPicker();
      if (!field) return;
      field.querySelectorAll('input[type="radio"]:checked').forEach(input => {
        input.checked = false;
        input.removeAttribute('checked');
      });
      const label = field.querySelector('[data-selected-value]');
      if (label && label.textContent.trim() !== 'Choose size') label.textContent = 'Choose size';
    }

    function syncButtons() {
      root.querySelectorAll(buttonSelector).forEach(button => {
        const label = button.querySelector('span');
        if (!label) return;
        if (!label.dataset.faOriginalText && label.textContent.trim() !== 'Choose size') {
          label.dataset.faOriginalText = label.textContent.trim();
        }
        if (!chosen() && hasAvailableSize) {
          button.disabled = false;
          if (label.textContent.trim() !== 'Choose size') label.textContent = 'Choose size';
        } else if (chosen() && label.textContent.trim() === 'Choose size') {
          label.textContent = label.dataset.faOriginalText || 'Add to bag';
        }
      });
    }

    function sync() {
      pending = false;
      if (!root.isConnected) return;
      if (!chosen()) clearImplicitSelection();
syncButtons();

// Reflect the explicit size choice without changing variant behaviour.
const heading = root.querySelector('[data-fa-size-heading-value]');
const radio = chosen()
  ? findPicker()?.querySelector('input[type="radio"]:checked')
  : null;
const label = radio ? radio.value : 'Choose your size';

if (heading && heading.textContent.trim() !== label) {
  heading.textContent = label;
}
    }
    function scheduleSync() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(sync);
    }

    function focusSize() {
      const field = findPicker();
      if (!field) return;
      field.scrollIntoView({ behavior: prefersReducedMotion() ? 'instant' : 'smooth', block: 'center' });
      field.setAttribute('tabindex', '-1');
      field.focus({ preventScroll: true });
    }

    // Prevent every premature add, even when the sticky button points outside
    // the main form. We do not depend on button text or selected input styling.
    root.addEventListener('click', event => {
      if (chosen() || !hasAvailableSize || !event.target.closest(buttonSelector)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      focusSize();
    }, true);
    root.addEventListener('submit', event => {
      if (chosen() || !hasAvailableSize || !event.target.matches('form[data-type="add-to-cart-form"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      focusSize();
    }, true);
    root.addEventListener('change', event => {
      if (!event.isTrusted || !event.target.closest('[data-fa-size-picker]')) return;
      root.dataset.faSizeChosen = 'true';
      // Let the theme perform its own stock, price and variant refresh.
      scheduleSync();
    }, true);

    // Shopify's ProductVariantSelects can replace its own controls, and also
    // replace the sticky bar's HTML after selection. Reassert the unchosen
    // state on the replacement, without intercepting the theme's fetch.
    if ('MutationObserver' in window) {
      const watch = root.querySelector('.product__variant-picker');
      const bar = root.querySelector('.product__sticky-cart');
      if (watch) new MutationObserver(scheduleSync).observe(watch, {childList:true, subtree:true});
      if (bar) new MutationObserver(scheduleSync).observe(bar, {childList:true, subtree:true});
    }
    root.dataset.initialVariantSyncDone = 'true';
    sync();
  }

  function scan(from = document) {
    if (from.matches?.(rootSelector)) init(from);
    from.querySelectorAll?.(rootSelector).forEach(init);
  }
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('product-info:loaded', event => init(event.target));
})();
